<template>
  <div id="app">
    <component :is="themeComponent" />
  </div>
</template>

<script>
import { DOMAIN_GOOGLE_GTAG, GOOGLE_TAG_MANAGERS } from "./utils/constant";
import {getGatagFile, getInviteCodeFile} from "./utils/request";
import Vue from "vue";
export default {
  name: "App",
  data() {
    return {
      googleGtag: null
    };
  },
  computed: {
    themeComponent: function() {
      const compMap = window.componentsConfig;
      const theme = process.env.theme;
      console.log(process.env.theme);
      return () => Promise.resolve(require(`${compMap[theme]}`));
    }
  },
  mounted() {
    this.insertGoogleNoscript();
      this.getGaTagData();
    this.getInviteData();
  },
  methods: {
      async getGaTagData(){
          const {status,body} = await getGatagFile()
          if (status === 200){
              this.googleGtag = body
              this.setDomainGoogleGtag();
          } else {
              this.googleGtag = DOMAIN_GOOGLE_GTAG
              this.setDomainGoogleGtag();
          }
      },
    insertGoogleNoscript() {
      const id = Object.entries(GOOGLE_TAG_MANAGERS).reduce(
        (acc, [host, v]) => {
          if (host == location.host) {
            return v;
          }
          return acc;
        },
        ""
      );
      if (!id) {
        return;
      }
      const nos = document.createElement("noscript");
      const ifr = document.createElement("iframe");
      ifr.setAttribute(
        "src",
        `https://www.googletagmanager.com/ns.html?id=${id}`
      );
      ifr.setAttribute("height", "0");
      ifr.setAttribute("width", "0");
      ifr.setAttribute("style", "display:none;visibility:hidden;");
      nos.appendChild(ifr);
      document.body.appendChild(nos);
    },
    setDomainGoogleGtag() {
      const host = location.host;
      if (host === "ls1v.xkiosx.xyz") {
        let innHtml = `!function (w, d, t) {
                       w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t][];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t][],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
                       ttq.load('CD96N9RC77U6290RBT10');
                       ttq.page();
                     }(window, document, 'ttq');`;
        var s = document.createElement("script");
        s.async = true;
        s.type = "text/javascript";
        s.innerHTML = innHtml;
        document.body.append(s);
      }
      if (Object.keys(this.googleGtag).indexOf(host) !== -1) {
        let tagId = this.googleGtag[host];
        let st = document.createElement("script");
        st.async = true;
        st.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
        document.body.append(st);
        let innHtml = `window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${tagId}');`;
        let st2 = document.createElement("script");
        st2.type = "text/javascript";
        st2.innerHTML = innHtml;
        document.body.append(st2);
      }
    },
      async getInviteData(){
        const data = await getInviteCodeFile();
        const {status,body} = data
          if (status === 200){
              Vue.prototype.inviteCodeObj = body
          }
      }
  }
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
}
</style>



// WEBPACK FOOTER //
// src/App.vue